export const GOALS_FETCH = 'GOALS_FETCH';
export const GOALS_FETCH_SUCCESS = 'GOALS_FETCH_SUCCESS';
export const GOALS_FETCH_ERROR = 'GOALS_FETCH_ERROR';
export const goalsFetch = (query) => ({type: GOALS_FETCH, query});
export const goalsFetchSuccess = (result, query) => ({type: GOALS_FETCH_SUCCESS, result, query});

export const GOAL_UPDATE = 'GOAL_UPDATE';
export const goalUpdate = (goalId, goal, updates, source) => ({
  type: GOAL_UPDATE,
  goalId,
  stateBeforeLocalUpdate: goal,
  updates: {
    ...updates,
    updatedAt: new Date()
  },
  source
});

export const GOAL_CHANGE_SCORE = 'GOAL_CHANGE_SCORE';
export const GOAL_CHANGE_SCORE_SUCCESS = 'GOAL_CHANGE_SCORE_SUCCESS';
export const GOAL_CHANGE_SCORE_ERROR = 'GOAL_CHANGE_SCORE_ERROR';
export const goalChangeScore = (goalId, score, source) => ({ type: GOAL_CHANGE_SCORE, goalId, score, source});

export const GOAL_ADDING_SHOW = 'GOAL_ADDING_SHOW';
export const goalAddingShow = () => ({type: GOAL_ADDING_SHOW});

export const GOAL_ADDING_HIDE = 'GOAL_ADDING_HIDE';
export const goalAddingHide = () => ({type: GOAL_ADDING_HIDE});

export const GOAL_ADDING_UPDATE = 'GOAL_ADDING_UPDATE';
export const goalAddingUpdate = value => ({type: GOAL_ADDING_UPDATE, value});

export const GOAL_CREATE = 'GOAL_CREATE';
export const GOAL_CREATE_SUCCESS = 'GOAL_CREATE_SUCCESS';
export const GOAL_CREATE_ERROR = 'GOAL_CREATE_ERROR';
export const goalCreate = (goal, source, successTitle, successMessage) => ({type: GOAL_CREATE, goal, source, successTitle, successMessage});

export const GOALS_RECEIVED = 'GOALS_RECEIVED';
export const goalsReceived = result => ({type: GOALS_RECEIVED, result});



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/actions.js
 **/